import * as React from 'react';
import './LogIn.css';

export const ImageContainer = () => {
    return (
        <div className="image-container">
            <div className="text-container">
                <h3>Dostęp do wszystkich serwisów <br /> KIF w jednym miejscu!</h3>
                <div className="portals-container">
                    <span className="portal-name">Znajdź Fizjoterapeutę</span>
                    <span className="portal-name">Finezjo</span>
                    <span className="portal-name">Portal Fizjoterapeuty</span>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Login/ImageContainer.tsx